import { styled } from '@mui/material/styles';
const Form = styled('form')({});
export default Form;
